module.exports = __webpack_public_path__ + "media/images/wastage-1831b4695436128f4270833a7683bc64.png";